// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { ProcedureItem_abstract } from './../abstract/SagaBase/ProcedureItem_abstract';
export class ProcedureItem extends ProcedureItem_abstract {}
